import styled from '@emotion/styled/macro';

import { DetailsContainer } from '../../../Overview/OverviewDetails/OverviewDetails';

export const StyledDetailsContainer = styled(DetailsContainer)`
  margin-top: 2rem;
`;
